if (!customElements.get('supplements-routine-stats')) {
  class SupplementsRoutineStats extends HTMLElement {
    connectedCallback() {
      this.values = Array.from(this.querySelectorAll('.supplements-routine__stat-value'));
      this.values.forEach((el) => {
        el.dataset.finalText = el.textContent.trim();
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        threshold: 0.4,
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    handleIntersection(entries) {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      if (!isVisible) return;

      this.observer.disconnect();
      this.values.forEach((el) => this.animateValue(el));
    }

    animateValue(el) {
      const finalText = el.dataset.finalText;
      const match = finalText.match(/^(\D*)([\d]+(?:[.,]\d+)?)(.*)$/);

      if (!match) return;

      const [, prefix, numberText, suffix] = match;
      const decimals = (numberText.split(/[.,]/)[1] || '').length;
      const target = parseFloat(numberText.replace(',', '.'));
      const duration = 1500;
      const startTime = performance.now();

      const step = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = (target * eased).toFixed(decimals);

        el.textContent = `${prefix}${current}${suffix}`;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = finalText;
        }
      };

      requestAnimationFrame(step);
    }
  }

  customElements.define('supplements-routine-stats', SupplementsRoutineStats);
}

document.querySelectorAll('[data-certificate-trigger]').forEach((trigger) => {
  const root = trigger.closest('.supplements-routine');
  const lightbox = root ? root.querySelector('[data-certificate-lightbox]') : null;
  const highlight = trigger.querySelector('strong, b');

  if (!lightbox || !highlight) return;

  const closeButton = lightbox.querySelector('.supplements-routine__lightbox-close');
  const track = lightbox.querySelector('[data-certificate-track]');
  const prev = lightbox.querySelector('[data-certificate-prev]');
  const next = lightbox.querySelector('[data-certificate-next]');
  const dots = Array.from(lightbox.querySelectorAll('[data-certificate-dot]'));
  const slideCount = track ? track.children.length : 0;

  const currentIndex = () => (track ? Math.round(track.scrollLeft / track.clientWidth) : 0);

  const goTo = (index) => {
    const target = Math.max(0, Math.min(slideCount - 1, index));
    track.scrollTo({ left: target * track.clientWidth });
  };

  const updateSlider = () => {
    const index = currentIndex();
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index >= slideCount - 1;
    dots.forEach((dot, i) => {
      dot.classList.toggle('supplements-routine__lightbox-dot--active', i === index);
    });
  };

  if (track && slideCount > 1) {
    track.addEventListener('scroll', updateSlider, { passive: true });
    if (prev) prev.addEventListener('click', () => goTo(currentIndex() - 1));
    if (next) next.addEventListener('click', () => goTo(currentIndex() + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') goTo(currentIndex() - 1);
      if (event.key === 'ArrowRight') goTo(currentIndex() + 1);
    });
    updateSlider();
  }

  let lastFocused = null;
  let closeTimer = null;

  highlight.classList.add('supplements-routine__trust-highlight');
  highlight.setAttribute('role', 'button');
  highlight.setAttribute('tabindex', '0');

  const openLightbox = () => {
    clearTimeout(closeTimer);
    lastFocused = document.activeElement;
    lightbox.hidden = false;
    if (track && slideCount > 1) {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      track.style.scrollBehavior = '';
      updateSlider();
    }
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(() => {
      lightbox.classList.add('supplements-routine__lightbox--open');
    });
    if (closeButton) closeButton.focus();
  };

  const closeLightbox = () => {
    lightbox.classList.remove('supplements-routine__lightbox--open');
    document.body.classList.remove('overflow-hidden');
    if (lastFocused) lastFocused.focus();
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      lightbox.hidden = true;
    }, 250);
  };

  highlight.addEventListener('click', openLightbox);
  highlight.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openLightbox();
    }
  });

  lightbox.querySelectorAll('[data-certificate-lightbox-close]').forEach((closeTrigger) => {
    closeTrigger.addEventListener('click', closeLightbox);
  });

  lightbox.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeLightbox();
  });
});
